import { ENTRIES } from 'client/api';
import { clientAdmin } from 'client/request';
import queryString from 'query-string';

const getEntries = async (type) => {
  const url = type ? `${ENTRIES}?${queryString.stringify({ type })}` : ENTRIES;
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await clientAdmin.get(url, {});
    return res.data;
  } catch (err) {
    throw err;
  }
};

export default {
  getEntries
};
